// MUI
import { Grid } from "@mui/material";

// Images
import { ReactComponent as NoBirthday } from "@/assets/images/widgets/NoBirthday.svg";
// Components
import { BirthdaysOfMonthLoader } from "../DashboardLoader";
import { IUsersByMonthOfBirthDayResponse } from "../../types/queries";
import { BirthdayItem } from "./BirthdayListItem";

interface IBirthdayListProps {
	data: IUsersByMonthOfBirthDayResponse[];
	isPending: boolean;
}

const BirthdaysList = ({ data, isPending }: Readonly<IBirthdayListProps>) => {
	if (isPending) {
		return <BirthdaysOfMonthLoader />;
	}

	if (!data.length) {
		return (
			<Grid container columnSpacing={1} className="pt-[15px]" rowSpacing={1}>
				<NoBirthday className="m-auto p-4 h-[177px]" aria-label="No Birthdays this month" />
			</Grid>
		);
	}

	return (
		<Grid container columnSpacing={1} rowSpacing={1}>
			{data?.map((item) => (
				<BirthdayItem key={item._id} name={item.fullName} birthDate={item.birthDate} />
			))}
		</Grid>
	);
};

export default BirthdaysList;
